<div [formGroup]="form">
	<p><strong>Dependant:</strong> {{ dependant.name }} ({{ dependant.relationship }})</p>

	<nz-form-item>
		<nz-form-label nzRequired>Cover Start Date</nz-form-label>
		<nz-form-control nzErrorTip="Required">
			<nz-date-picker formControlName="fromDate" style="width: 100%"></nz-date-picker>
		</nz-form-control>
	</nz-form-item>
	<nz-divider></nz-divider>


	<nz-table
		#extendedTable
		[nzBordered]="true"
		[nzLoading]="false"
		[nzData]="[1]"
		[nzFrontPagination]="false"
		[nzShowSizeChanger]="false">
		<thead>
			<tr>
				<th>Name</th>
				<th>Description</th>
				<th>Action</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let extended of product.extendeds">
				<td>{{extended.name}}</td>
				<td>{{extended.description}}</td>
				<td>
					<button *ngIf="current && current.id == extended.id" nz-button nzType="primary" (click)="selected(extended)">
						Select
					</button>
					<button *ngIf="!current || current.id != extended.id" nz-button nzType="dashed" (click)="selected(extended)">
						Select
					</button>
				</td>
			</tr>
		</tbody>
	</nz-table>


	<nz-divider></nz-divider>

	<div class="text-end">
		<button nz-button nzDanger *ngIf="current" (click)="remove()">Remove</button>
		<button nz-button (click)="cancel()">Cancel</button>
	</div>
</div>


